export const queryKeys = {
  exams: {
    all: ["exams"] as const,
    lists: () => [...queryKeys.exams.all, "list"] as const,
    mine: () => [...queryKeys.exams.lists(), "mine"] as const,
    catalog: () => [...queryKeys.exams.lists(), "all"] as const,
    detail: (slug: string) => [...queryKeys.exams.all, "detail", slug] as const,
  },

  categories: {
    all: ["categories"] as const,
    list: (slug: string) => [...queryKeys.categories.all, slug] as const,
  },

  questions: {
    all: ["questions"] as const,
    lists: (slug: string) => [...queryKeys.questions.all, slug, "list"] as const,
    list: (
      slug: string,
      params: {
        page?: number;
        perPage?: number;
        categoryId?: number;
        search?: string;
        fromNumber?: number;
        toNumber?: number;
        isMultiple?: boolean;
        hasExplanation?: boolean;
      },
    ) => [...queryKeys.questions.lists(slug), params] as const,
    detail: (slug: string, id: number) =>
      [...queryKeys.questions.all, slug, "detail", id] as const,
    random: (slug: string, count: number, categoryId?: number) =>
      [...queryKeys.questions.all, slug, "random", { count, categoryId }] as const,
    drafts: (slug: string, page: number) =>
      [...queryKeys.questions.all, slug, "drafts", page] as const,
  },

  analytics: {
    all: ["analytics"] as const,
    summary: (slug: string) => [...queryKeys.analytics.all, slug, "summary"] as const,
    categoryStats: (slug: string) =>
      [...queryKeys.analytics.all, slug, "categories"] as const,
    weakQuestions: (slug: string, limit: number) =>
      [...queryKeys.analytics.all, slug, "weak", limit] as const,
    progress: (slug: string, days: number) =>
      [...queryKeys.analytics.all, slug, "progress", days] as const,
  },

  tests: {
    all: ["tests"] as const,
    history: (slug: string, questionNumber?: number) =>
      [...queryKeys.tests.all, slug, "history", { questionNumber }] as const,
    session: (slug: string, id: string) =>
      [...queryKeys.tests.all, slug, "session", id] as const,
  },

  submissions: {
    all: ["submissions"] as const,
    mine: () => [...queryKeys.submissions.all, "mine"] as const,
    admin: () => [...queryKeys.submissions.all, "admin"] as const,
  },

  reports: {
    all: ["reports"] as const,
    mine: () => [...queryKeys.reports.all, "mine"] as const,
    admin: (status?: string) =>
      [...queryKeys.reports.all, "admin", { status }] as const,
  },

  examRequests: {
    all: ["examRequests"] as const,
    mine: () => [...queryKeys.examRequests.all, "mine"] as const,
    pending: () => [...queryKeys.examRequests.all, "pending"] as const,
  },

  blockedIPs: {
    all: ["blockedIPs"] as const,
  },
  adminUsers: {
    all: ["adminUsers"] as const,
    list: () => [...queryKeys.adminUsers.all, "list"] as const,
  },

  groups: {
    all: ["groups"] as const,
    mine: () => [...queryKeys.groups.all, "mine"] as const,
    admin: () => [...queryKeys.groups.all, "admin"] as const,
    detail: (gid: string) => [...queryKeys.groups.all, "detail", gid] as const,
    members: (gid: string) =>
      [...queryKeys.groups.all, "members", gid] as const,
    leaderboard: (
      gid: string,
      opts: { period?: string; from?: string; to?: string; exam?: string },
    ) => [...queryKeys.groups.all, "leaderboard", gid, opts] as const,
  },

  invitations: {
    all: ["invitations"] as const,
    mine: () => [...queryKeys.invitations.all, "mine"] as const,
  },
} as const;
